// @flow
import React from 'react'
import i18n from 'i18next'
import ProductItem from '../ProductItem'

type Props = {
  recommendations: Array<Object>,
  addToCart: Function,
  cart: Object
}

const Recommendations = (props: Props) => {
  const getItemsInCart = (product: Object): number => {
    return props.cart.itemList[product.id]
  }

  const getFormattedPrice = (price: number): string => {
    return `${price} €`
  }

  return (
    <>
      {props.recommendations.map(product => (
        <ProductItem
          key={product.id}
          addToCart={props.addToCart}
          cartID={props.cart.id}
          id={product.id}
          image={product.image}
          name={product.name}
          numItems={getItemsInCart(product)}
          price={getFormattedPrice(product.price)}
          addButtonText={i18n.t('checkout.add')}
        />
      ))}
    </>
  )
}

export default Recommendations
